import DocumentMRDRM from '../responsemodel/DocumentMRDRM'
import MrdDocuments from '../../models/MrdDocuments'
import DataMapper from './DataMapperBilling'
export default class DocumentMRDDataMapper extends DataMapper<DocumentMRDRM, MrdDocuments[]> {
  map = (rm: any) => {
    let doc: MrdDocuments[] = [];
    let tmp = new MrdDocuments (
      rm._id,
      rm.case_id,
      rm.investigator_id,
      rm.hospital_id,
      rm.expense_details,
      rm.case?.claim_number ?? '',
      rm.investigator?.emp_id ?? "",
      rm.investigator?.name ?? "",
      rm.hospital?.name ?? "",
      rm.hospital?.state,
      rm.hospital?.district,
      rm.allocator?.name ?? "",
      rm.tpa ? `${rm.tpa?.name ?? ""}/${rm.insurancecompnay?.name ?? ""}` : rm.insurancecompnay?.name ?? "",
      rm.createdAt,
      rm.updatedAt
    )
    doc.push(tmp);
    return doc;
  }  
  //   rm.forEach((singleDoc) => {
  //     let tmp  = new MrdDocuments (
  //       singleDoc.id,
  //       singleDoc.case_id,
  //       singleDoc.investigator_id,
  //       singleDoc.hospital_id,
  //       singleDoc.expense_details,
  //       singleDoc.case?.claim_number ?? '',
  //       singleDoc.investigator?.emp_id ?? "",
  //       singleDoc.investigator?.name ?? "",
  //       singleDoc.hospital?.name ?? "",
  //       singleDoc.hospital?.state,
  //       singleDoc.hospital?.district,
  //       singleDoc.allocator?.name ?? "",
  //       singleDoc.tpa ? `${singleDoc.tpa?.name ?? ""}/${singleDoc.insurancecompnay?.name ?? ""}` : singleDoc.insurancecompnay?.name ?? "",
  //       singleDoc.createdAt,
  //       singleDoc.updatedAt
  //     )
  //     mrdDoc.push(tmp);
  //   })
  //   return mrdDoc
  // }
}


